




































import { Component, Vue, Prop } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import CustomExistingPortfolioV2 from '@company-common/model/kyc-form/existing-plans/CustomExistingPortfolioV2'
import { FormStructure } from '@master/model/structure/FormStructure'
import { IDateService } from '@master/services/IDateService'
import { convertToCurrencyFormat } from '@core/tools/Formatter'

@Component({
  components: {
  }
})
export default class TheCurrentPlansGallery extends Vue {
  @Prop() readonly portfolios
  @Prop() readonly isClient2Included!: boolean
  @Prop() readonly structure: FormStructure<CustomExistingPortfolioV2>
  @Prop() readonly currencySetting: string

  @inject()
  private dateService: IDateService

  isShowItem (item: CustomExistingPortfolioV2) {
    return item.owner !== 'C2' || (item.owner === 'C2' && this.isClient2Included)
  }

  getCardTitle (item: CustomExistingPortfolioV2) {
    if (!item) return 'Invalid Card'
    const owner = item.owner ? `(${item.owner})` : ''
    return `${item.policyName} ${owner}`
  }

  getDisplayValue (idx: number, key: string) {
    const config = (this.structure as Array<any>).find(struct => struct.key === key)
    if (!config) return 'Invalid config'
    const curValue = this.portfolios[idx][key]
    if (config.options) return config.options.find(opt => opt.value === curValue)?.label || ''
    if (config.type === 'date') return this.dateService.format(curValue, 'DD-MM-YYYY')
    if (config.type === 'currency') return convertToCurrencyFormat(curValue, this.currencySetting)
    return curValue
  }

  createPortfolio () {
    this.$emit('create')
  }

  editPortfolio (index) {
    this.$emit('edit', index)
  }

  removePortfolio (index) {
    this.$emit('remove', index)
  }
}
